import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import AuthService from "@/classes/AuthService";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const checkAuthSession = () => {
    const onAuthRoute = router.currentRoute.value.meta.needsAuth
    if(!AuthService.isAuthenticated() && onAuthRoute) {
        AuthService.logout()
    }
}

onMounted( () => {
    checkAuthSession();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), { animated: "false" })
    ]),
    _: 1
  }))
}
}

})